import { render } from "./ModulesSidebar.vue?vue&type=template&id=1175f9b7&scoped=true"
import script from "./ModulesSidebar.vue?vue&type=script&lang=js"
export * from "./ModulesSidebar.vue?vue&type=script&lang=js"

import "./ModulesSidebar.vue?vue&type=style&index=0&id=1175f9b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1175f9b7"]])

export default __exports__